import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MagoCloudService } from 'src/app/core/services/mago-cloud.service';
import { InstSnapVersInfo, InstanceVersionInfo, SnapshotType } from 'src/app/model/instance';

@Component({
    selector: 'ms-snapshots-selection',
    templateUrl: './snapshots-selection.component.html',
    styleUrls: ['./snapshots-selection.component.scss'],
})
export class SnapshotsSelectionComponent implements OnInit {
    @Input() selecteInstanceKey: string = '';
    @Input() defaultSnapshotID: string = '';
    @Input() readonly: boolean;
    @Output() snapshotSelectedDescri = new EventEmitter<string>();
    @Output() snapshotSelectedValue = new EventEmitter<string>();

    public selectedSnapshotID: string = '';
    public snapshotDescription: string = '';

    constructor(public magoCloudService: MagoCloudService) {}

    ngOnInit(): void {}

    public async onSnapshotChange(event: any) {
        this.snapshotDescription = this.magoCloudService?.snapShotsList.find((x) => x.InstanceKey == event.value)?.Description;
        this.selectedSnapshotID = event.value;
        this.snapshotSelectedValue.emit(this.selectedSnapshotID);
        this.snapshotSelectedDescri.emit(this.snapshotDescription);
    }
}
